import Vue from 'vue'
import Router from 'vue-router'
import Index from '@/components/index'
import kontakt from '@/components/kontakt'
import products from '@/components/products'
import Product from '@/components/Product'
import impressum from '@/components/impressum'
import na from '@/components/na'
import prospekt from '@/components/prospektform'
import service from '@/components/servicehotline'
import newsletter from '@/components/newsletter'
import agb from '@/components/agbs'
import about from '@/components/wiruberuns'
import portrait from '@/components/portrait'
import historie from '@/components/historie'
import tradefairs from '@/components/tradefairs'
import NotFound from '@/components/not_found'

/* eslint-disable */
Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [{
      path: '/',
      name: 'Index',
      component: Index
    },
    {
      path: '/contact',
      name: 'contact',
      component: kontakt
    },
    {
      path: '/impressum',
      name: 'impressum',
      component: impressum
    },
    {
      path: '/abg',
      name: 'agb',
      component: agb
    },
    {
      path: '/products',
      name: 'products',
      component: products
    },
    {
      path: '/product/:id',
      name: 'product',
      component: Product,
      props: true
    },
    {
      path: '/product',
      redirect: { name: 'products' }
    },
    {
      path: '/na',
      name: 'na',
      component: na
    },
    {
      path: '/about',
      name: 'about',
      component: about
    },
    {
      path: '/portrait',
      name: 'portrait',
      component: portrait
    },
    {
      path: '/historie',
      name: 'historie',
      component: historie
    },
    {
      path: '/aktuelles',
      name: 'aktuelles',
      redirect:  { name: 'na' }
    },
    {
      path: '/press',
      name: 'press',
      redirect:  { name: 'na' }
    },
    {
      path: '/support',
      name: 'support',
      component: service
    },
    {
      path: '/quality',
      name: 'quality',
      redirect:  { name: 'na' }
    },
    {
      path: '/downloads',
      name: 'downloads',
      redirect:  { name: 'na' }
    },
    {
      path: '/faq',
      name: 'faq',
      redirect:  { name: 'na' }
    },
    {
      path: '/prospekt',
      name: 'prospekt',
      component: prospekt
    },
    {
      path: '/newsletter',
      name: 'newsletter',
      component: newsletter
    },
    {
      path: '/contactpoint',
      name: 'contactpoint',
      redirect:  { name: 'na' }
    },
    {
      path: '/tradefairs',
      name: 'tradefairs',
      component: tradefairs
    },
    {
      path: '*',
      component: NotFound
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js